export enum AssetUsageRecordStatus {
  Created = "Created",
  PreparedToSend = "PreparedToSend",
  PreparedToDelete = "PreparedToDelete",
  Expired = "Expired",
  Sent = "Sent",
  WrittenOff = "WrittenOff",
  Error = "Error",
  Deleted = "Deleted",
}
